'use strict';

var INVALID_ARRIVAL_HOUR = [0, 3];
const TRIP_TYPES = {
    ROUND_TRIP: 'roundTrip',
    ONE_WAY: 'oneWayTrip',
};
var TYPE_ERRORS = [{
    type: 'no_hotel_results',
    check: Odigeo._.partialRight(Odigeo._.has, 'no_hotel_results'),
    image: 'odf-spot-hotel-error',
    onLoadTracking: 'nag_error_postbook_noavailable_shown',
    buttonTracking: 'nag_error_postbook_noavailable_search',
}, {
    type: 'no_booking_found',
    check: Odigeo._.partialRight(Odigeo._.has, 'no_booking_found'),
    image: 'odf-spot-bellboy-sad',
    onLoadTracking: 'nag_error_postbook_nobookingfound_shown',
    buttonTracking: 'nag_error_postbook_nobookingfound_search',
}, {
    type: 'same_day_trip',
    check: isSameDayTrip,
    image: 'odf-spot-bellboy-sad',
    onLoadTracking: 'nag_error_postbook_sametrip_shown',
    buttonTracking: 'nag_error_postbook_sametrip_shown',
}];

function getOutboundItineraryDeparture(booking) {
    return Odigeo._.first(Odigeo._.first(Odigeo._.get(booking, 'itineraryBookings.itinerarySegments')).sections).section;
}

function getOutboundItineraryArrival(booking) {
    return Odigeo._.last(Odigeo._.first(Odigeo._.get(booking, 'itineraryBookings.itinerarySegments')).sections).section;
}

function getReturnItineraryDeparture(booking) {
    return Odigeo._.first(Odigeo._.last(Odigeo._.get(booking, 'itineraryBookings.itinerarySegments')).sections).section;
}

function getReturnItinerarySecondDeparture(booking) {
    return Odigeo._.get(booking, 'itineraryBookings.itinerarySegments[1].sections[0].section');
}

function isSameDayTrip(booking) {
    if (Odigeo._.has(booking, 'itineraryBookings') && booking.itineraryBookings.bookingItinerary.tripType !== 'ONE_WAY') {
        const isRoundTrip = booking.itineraryBookings.bookingItinerary.tripType === 'ROUND_TRIP';
        const outboundDepartureDate = new Date(getOutboundItineraryDeparture(booking).departureDate).getDate();
        const returnSecondDepartureDate = new Date(getReturnItinerarySecondDeparture(booking).departureDate).getDate();

        return isRoundTrip && outboundDepartureDate === returnSecondDepartureDate;
    }
}

function getDateBefore(date) {
    const dateBefore = new Date(date);

    dateBefore.setDate(dateBefore.getDate() - 1);

    return dateBefore;
}

function hasHotelBookingAvailableAtMidnight(arrivalFlight) {
    const arrivalHour = new Date(arrivalFlight.arrivalDate).getHours();

    return INVALID_ARRIVAL_HOUR[0] <= arrivalHour && arrivalHour < INVALID_ARRIVAL_HOUR[1];
}

function checkAvailableHotelPostBooking(booking) {
    return _(TYPE_ERRORS).reduce(function(types, errors) {
        return types.concat(errors.check(booking) && errors.type);
    }, []).filter(Boolean);
}

function setSearchParameters(booking, checkInDate, checkOutDate) {
    const searchParams = {};
    const tripType = booking.itineraryBookings.bookingItinerary.tripType;

    searchParams.buyPath = 'POST_BOOKING_ACCOMMODATION';
    searchParams.cabinClass = booking.itineraryBookings.itinerarySegments[0].sections[0].section.cabinClass;
    searchParams.type = TRIP_TYPES[tripType];
    searchParams.accommodationDestination = {
        geoNodeId: booking.itineraryBookings.bookingItinerary.arrival.geoNodeId,
        iata: booking.itineraryBookings.bookingItinerary.arrival.iataCode,
        name: booking.itineraryBookings.bookingItinerary.arrival.name,
    };
    searchParams.searchSegments = buildSearchSegmentRequestsFromBookingInfo(booking);
    searchParams.checkInDate = checkInDate;
    searchParams.checkOutDate = checkOutDate;

    searchParams.numAdults = getNumberTravellers(booking.travellers, 'ADULT');
    searchParams.numChildren = getNumberTravellers(booking.travellers, 'CHILD');
    searchParams.numInfants = getNumberTravellers(booking.travellers, 'INFANT');

    Odigeo.Session.set('searchParameters', JSON.stringify(searchParams));
}

function getFormatAccommodationDate(date) {
    return Odigeo.Utils.formatDate(date, Odigeo.Utils.formatDate.masks.isoDate);
}

function getNumberTravellers(travellers, type) {
    return _(travellers).filter(function(traveller) {
        return traveller.travellerType === type;
    }).size();
}

function getCheckInDate(arrivalFlight) {
    return hasHotelBookingAvailableAtMidnight(arrivalFlight)
        ? getDateBefore(arrivalFlight.arrivalDate).getTime()
        : arrivalFlight.arrivalDate;
}

function buildSearchSegmentRequestsFromBookingInfo(booking) {
    const bookingSegments = booking.itineraryBookings.itinerarySegments;
    let segmentRequests = [];

    for (let i = 0; i < bookingSegments.length; i++) {
        segmentRequests.push({});
        segmentRequests[i].departure = {
            geoNodeType: bookingSegments[i].sections[0].section.from.type.toUpperCase(),
            type: bookingSegments[i].sections[0].section.from.type.toUpperCase(),
            name: bookingSegments[i].sections[0].section.from.cityName,
            countryCode: bookingSegments[i].sections[0].section.from.countryCode,
            country: bookingSegments[i].sections[0].section.from.countryName,
            city: bookingSegments[i].sections[0].section.from.name,
            iata: bookingSegments[i].sections[0].section.from.iataCode,
            geoNodeId: bookingSegments[i].sections[0].section.from.geoNodeId,
        };
        segmentRequests[i].destination = {
            geoNodeType: bookingSegments[i].sections[bookingSegments[i].sections.length - 1].section.to.type.toUpperCase(),
            type: bookingSegments[i].sections[bookingSegments[i].sections.length - 1].section.to.type.toUpperCase(),
            name: bookingSegments[i].sections[bookingSegments[i].sections.length - 1].section.to.cityName,
            countryCode: bookingSegments[i].sections[bookingSegments[i].sections.length - 1].section.to.countryCode,
            country: bookingSegments[i].sections[bookingSegments[i].sections.length - 1].section.to.countryName,
            city: bookingSegments[i].sections[bookingSegments[i].sections.length - 1].section.to.name,
            iata: bookingSegments[i].sections[bookingSegments[i].sections.length - 1].section.to.iataCode,
            geoNodeId: bookingSegments[i].sections[bookingSegments[i].sections.length - 1].section.to.geoNodeId,
        };
        segmentRequests[i].dateStr = Odigeo.Utils.formatDate(bookingSegments[i].sections[0].section.departureDate,
            Odigeo.Utils.formatDate.masks.isoDate);
        segmentRequests[i].date = Odigeo.Utils.formatDate(bookingSegments[i].sections[0].section.departureDate,
            Odigeo.Utils.formatDate.masks.isoDate);
        segmentRequests[i].time = Odigeo.Utils.formatDate(bookingSegments[i].sections[0].section.departureDate,
            Odigeo.Utils.formatDate.masks.hourMinutes);
    }
    return segmentRequests;
}

function parserAccommodationSearchData(booking) {
    const dayMiliseconds = 86400000;
    const arrivalFlight = getOutboundItineraryArrival(booking);
    let checkOutDate;
    let returnFlight;
    const tripType = booking.itineraryBookings.bookingItinerary.tripType;
    const timeStamp = Date.now();
    const checkInDate =
        timeStamp > arrivalFlight.arrivalDate ?
            Odigeo.Utils.formatDate(timeStamp, Odigeo.Utils.formatDate.masks.isoDate):
            getFormatAccommodationDate(getCheckInDate(arrivalFlight));
    let isLongTrip;

    if (tripType === 'ONE_WAY') {
        checkOutDate = getFormatAccommodationDate(Date.parse(checkInDate) + dayMiliseconds);
    } else if (tripType === 'ROUND_TRIP') {
        returnFlight = getReturnItineraryDeparture(booking);
        isLongTrip =
            (((returnFlight.arrivalDate - arrivalFlight.arrivalDate) / dayMiliseconds ) >= 30);
        checkOutDate =
            isLongTrip ?
                getFormatAccommodationDate(getCheckInDate(arrivalFlight) + 2 * dayMiliseconds) :
                getFormatAccommodationDate(returnFlight.departureDate);
    } else {
        returnFlight = getReturnItinerarySecondDeparture(booking);
        checkOutDate = getFormatAccommodationDate(returnFlight.departureDate);
    }
    setSearchParameters(booking, checkInDate, checkOutDate);
    return {
        accommodationSearchRequest: {
            destination: {
                iata: arrivalFlight.to.iataCode,
                name: arrivalFlight.to.name,
                geoNodeId: arrivalFlight.to.geoNodeId,
                type: arrivalFlight.to.type.toUpperCase(),
            },
            checkInDate: checkInDate,
            checkOutDate: checkOutDate,
            searchType: 'POST_BOOKING',
        },
        itinerarySearchRequest: {
            numAdults: getNumberTravellers(booking.travellers, 'ADULT'),
            numChildren: getNumberTravellers(booking.travellers, 'CHILD'),
            numInfants: getNumberTravellers(booking.travellers, 'INFANT'),
            cabinClass: arrivalFlight.cabinClass,
            segmentRequests: buildSearchSegmentRequestsFromBookingInfo(booking),
            type: tripType,
        },
    };
}

function getAnErrorProperty(errorType, property) {
    return TYPE_ERRORS[
        Odigeo._.findIndex(TYPE_ERRORS, function(e) {
            return e.type === errorType;
        })
    ][property];
}

module.exports = Odigeo.Model.extend({
    defaults: {
        search: {},
        errorType: [],
        pictureType: '',
        buttonTracking: '',
        onLoadTracking: '',
    },

    loadPostBookingAccommodation: function(bookingDetail) {
        var bookingHotelValidation = checkAvailableHotelPostBooking(bookingDetail);

        if (Odigeo._.isEmpty(bookingHotelValidation)) {
            this.set('search', parserAccommodationSearchData(bookingDetail));
            Odigeo.trigger(this.widget.id + ':available', this.get('search'));
        } else {
            var error = Odigeo._.first(bookingHotelValidation);

            Odigeo.trigger(this.widget.id + ':loadError');
            this.set({
                'errorType': error,
                'pictureType': getAnErrorProperty(error, 'image'),
                'onLoadTracking': getAnErrorProperty(error, 'onLoadTracking'),
                'buttonTracking': getAnErrorProperty(error, 'buttonTracking'),
            });
        }
    },
});
